"use client"
import { getTrackAnalysisExperts } from '@/app/utils/request/requestList';
import { useEffect, useState } from "react";
import styled from "styled-components";
import React from 'react';
import { useLanguage } from "@/app/utils/LanguageContext";
import { textSize, text_size } from "@/app/utils/MixinSize";
import { useMyContext } from '@/app/utils/MyContext';

const ImgExpert = styled.img`
  width: 100px;
  float: left;
`;

const ImgExpertM = styled.img`
  width: 100px;
  float: right;
  margin: 0 12px 12px 12px;
`;

const DivExpertTitle = styled.div`
    ${text_size(15)}
    font-weight: 500;
    line-height: 17px;
    padding: 0px 12px 4px 0px;
`;

const DivExpertTitleM = styled.div`
    ${text_size(15)}
    font-weight: 500;
    line-height: 17px;
    padding-bottom: 4px;
`;

const DivExpertContent = styled.div`
    min-height: 130px;
`;

const DivContent = styled.div`
    ${text_size(13)}
    font-weight: 500;
`;

const ExpertProfileWrapper = styled.div`
    background: var(--palette-grey-100);
    display: flex;
    gap: 12px;
    padding: 12px;
    border-radius: 4px;
`;

const ExpertProfileWrapperM = styled.div`
    background: var(--palette-grey-100);
    padding: 12px;
    border-radius: 4px;
`;

interface propType {
    type?: string;
    expertName?: string;
}

const ExpertProfile: React.FC<propType> = (props: propType) => {
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { state: myContextState} = useMyContext();
    const [trackAnalysisExperts, setTrackAnalysisExperts] = useState<any>(null);

    useEffect(() => {
        if(props?.expertName)
        {
            getTrackAnalysisExperts(lang.langCode, props?.expertName || '')
                .then((resExperts: any) => {
                    setTrackAnalysisExperts(resExperts?.item);
                })
                .catch((e: any) => {
                    console.log(e);
                });
        }
    }, [props?.expertName]);

    return (
        <> {props.type === "pc" ?
            (
                trackAnalysisExperts ?
                    <>
                        <ExpertProfileWrapper id="expert_profile_pc">
                            <div>
                                <ImgExpert src={trackAnalysisExperts?.expertPicture?.src} alt={trackAnalysisExperts?.expertPicture?.alt} />
                            </div>
                            <DivExpertContent>
                                <DivExpertTitle>{trackAnalysisExperts?.expertName?.value}</DivExpertTitle>
                                <DivContent dangerouslySetInnerHTML={{ __html: trackAnalysisExperts?.expertIntroduction?.value }}></DivContent>
                            </DivExpertContent>
                        </ExpertProfileWrapper>
                    </>
                    : <></>

            ) : (
                trackAnalysisExperts ?
                    <>
                        <ExpertProfileWrapperM id="expert_profile_mobile">
                            <div>
                            <ImgExpertM src={trackAnalysisExperts?.expertPicture?.src} alt={trackAnalysisExperts?.expertPicture?.alt} />
                            </div>
                            <DivExpertContent>
                                <DivExpertTitleM>{trackAnalysisExperts?.expertName?.value}</DivExpertTitleM>
                                <DivContent dangerouslySetInnerHTML={{ __html: trackAnalysisExperts?.expertIntroduction?.value }}></DivContent>
                            </DivExpertContent>
                        </ExpertProfileWrapperM>
                    </>
                    : <></>
            )
        }
        </>
    )
}

export default ExpertProfile; 